import { Divider } from "@mui/material";
import React, { useEffect } from "react";

const SocialSection = () => {
    useEffect(() => {
        // Load Elfsight script only once
        const script = document.createElement("script");
        script.src = "https://static.elfsight.com/platform/platform.js";
        script.defer = true;
        document.body.appendChild(script);
    }, []);

    return (
        <>
        <Divider/>
        <section
            style={{
                // backgroundColor: "#000",
                color: "#fff",
                // padding: "60px 20px",
                textAlign: "center",
                marginBottom:"50px",
                marginTop:"50px"
            }}
        >
            {/* Google Reviews */}
            <div style={{ margin: "60px 0" }}>
                {/* Replace with your Elfsight Google Reviews App ID */}
                <div className="elfsight-app-ab58cf9b-8239-4a3f-a933-5a34f4bdce47"></div>
            </div>
         

            {/* WhatsApp Widget (Floating at bottom-right) */}
            <div className="elfsight-app-d0fa5087-f3c7-4421-ad2f-148647315ccc"></div>
        </section>
        <Divider/>
        <section
            style={{
                marginTop:"20px",
                // backgroundColor: "#000",
                color: "#fff",
                // padding: "60px 20px",
                textAlign: "center",
            }}
        >
               {/* Instagram Feed */}
               <div style={{ margin: "40px 0" }}>
                {/* Replace with your Elfsight Instagram App ID */}
                <div className="elfsight-app-506e05ec-ccb4-4bf7-b394-56874e7bc857"></div>
            </div>
        </section>
        </>
    );
};

export default SocialSection;
